import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import moment from 'moment';

import { UnfinishedWorkModal } from 'web-ui-components/lib/organisms/modals';

import withContent from '../../containers/withContent';
import content, { contentPropTypes } from './UnSavedWarningModal.content';

const UnSavedWarningModal = ({
	isModalOpen,
	handleClose,
	handleBack,
	content: { destructiveActionButtonText, safeActionButtonText, title, textBody },
	user = '',
	dateTime = undefined,
}) => (
	<UnfinishedWorkModal
		destructiveActionButtonText={destructiveActionButtonText.replace('[[user]]', user)}
		isOpen={isModalOpen}
		onClose={handleClose}
		onDestructiveAction={handleBack}
		safeActionButtonText={safeActionButtonText}
		titleText={title}
	>
		<p>{textBody.replace('[[user]]', user).replace('[[datetime]]', moment(Number(dateTime)).format('LT'))}</p>
	</UnfinishedWorkModal>
);

UnSavedWarningModal.defaultProps = {
	isModalOpen: false,
};

UnSavedWarningModal.propTypes = {
	isModalOpen: PropTypes.bool,
	handleClose: PropTypes.func.isRequired,
	handleBack: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	user: PropTypes.string,
	dateTime: PropTypes.string,
};

export default compose(withContent({ content }))(UnSavedWarningModal);
